var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 6.5V11.6H2.4V6.5H7H11.6ZM11.5243 5.5L10.4909 2.4H7.5V5.5H11.5243ZM2.47573 5.5H6.5V2.4H3.50906L2.47573 5.5ZM1 5.66228V12C1 12.5523 1.44772 13 2 13H12C12.5523 13 13 12.5523 13 12V5.66228C13 5.5548 12.9827 5.44802 12.9487 5.34605L11.7279 1.68377C11.5918 1.27543 11.2097 1 10.7792 1H3.22076C2.79033 1 2.40819 1.27543 2.27208 1.68377L1.05132 5.34605C1.01733 5.44802 1 5.5548 1 5.66228Z",
    fill: "currentColor",
    fillOpacity: 0.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOutline);
export default __webpack_public_path__ + "static/media/box_outline.88d581a4.svg";
export { ForwardRef as ReactComponent };